import React, { ReactNode, ReactElement } from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import styles from "./ListItemWithControls.module.css";

interface ListItemWithControlsProps {
  title: ReactNode;
  description?: ReactNode;
  quantityLabel?: ReactElement;
  addOn?: ReactNode;
  children: ReactNode;
}

/**
 * Wraps a FixaListViewItem with controls rendered below it
 * Used in media quantity selection (grouped list view pattern)
 */
const ListItemWithControls = ({
  title,
  description,
  quantityLabel,
  addOn,
  children,
}: ListItemWithControlsProps) => {
  return (
    <>
      <FixaListViewItem
        size="medium"
        showDivider={false}
        title={
          typeof title === "string" ? (
            <FixaText textStyle="Heading.S">{title}</FixaText>
          ) : (
            (title as ReactElement)
          )
        }
        description={
          typeof description === "string" ? (
            <FixaText textStyle="Body.M">{description}</FixaText>
          ) : (
            (description as ReactElement | undefined)
          )
        }
        quantityLabel={quantityLabel}
        addOn={
          typeof addOn === "string" ? (
            <FixaText textStyle="Body.S">{addOn}</FixaText>
          ) : (
            addOn
          )
        }
      />
      <div className={styles["controlsContainer"]}>{children}</div>
    </>
  );
};

export default ListItemWithControls;
